import { render, staticRenderFns } from "./chat_v2.vue?vue&type=template&id=50799171&scoped=true&"
import script from "./chat_v2.vue?vue&type=script&lang=js&"
export * from "./chat_v2.vue?vue&type=script&lang=js&"
import style0 from "./chat_v2.vue?vue&type=style&index=0&id=50799171&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50799171",
  null
  
)

export default component.exports